import {
  ESportsbookLayoutTypes,
  ESportsbookPageTypes
} from 'interfaces/sportsbook-configs';

export const TARGET_IDS_BY_LAYOUT: Record<string, string> = {
  [String(ESportsbookLayoutTypes.EUROPEAN) + String(ESportsbookPageTypes.live)]:
    'EuropeanLiveContentWrapper',
  [String(ESportsbookLayoutTypes.EUROPEAN) +
  String(ESportsbookPageTypes.prematch)]: 'desktopSportsbookEuropeanPrematch',
  [ESportsbookLayoutTypes.AMERICAN]: 'desktopMiddleContentWrapper',
  [ESportsbookLayoutTypes.CLASSIC]: 'desktopScrollArea',
  [ESportsbookLayoutTypes.ADVANCED]: 'advancedMiddleScrollArea'
};
